/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import get from "lodash/get";
import { StoryElement, WithLazy } from "@quintype/components";
import throttle from "lodash/throttle";

import Tags from "../story-elements/tags";
import AlsoRead from "../story-elements/also-read";
import Slideshow from "../story-elements/slide-show";
import Attachment from "../story-elements/attachment";
import FactCheckView from "../story-elements/fact-check";
import ImageGallery from "../story-elements/image-gallery";
import SponsoredTag from "../story-elements/sponsored-tag";
import MovieReviewView from "../story-elements/movie-review";
import GadgetReviewView from "../story-elements/gadget-review";
import ReferenceElement from "../story-elements/reference-element";
import BookReviewView from "../story-elements/book-review";
import SubscribeCard from "../../molecules/subscribe-card";
import PublishedAt from "./published-at";

import SectionStories from "./section-stories";

import { AdContainer } from "../../ads";
import TaboolaAd from "../../ads/taboola-ad";

import MobileBottomWidgets from "../mobile-bottom-widgets";

import BlockQuoteIcon from "../../atoms/icons/blockquote-icon";
import QuoteIcon from "../../atoms/icons/quote-icon";
import PromotionalMessage from "./promotional-message";
import ImagewithCaption from "../../molecules/Image-caption";
import ImagewithCaptionWithoutShare from "../../molecules/image-without-share";

import { storyPageBodyAd } from "../../../components/helper/utils";

import { getPrimaryEmbed } from "../story-header/embed-element";

import "./story-elements.m.css";
import QandA from "./q-and-a";

const fourthTextStoryElementID = (story) => {
  const textStoryElements = [];
  story.cards.map((element) =>
    element["story-elements"]?.map((element) => {
      if (element.subtype === null && element.type === "text") {
        textStoryElements.push(element);
      }
    })
  );
  return textStoryElements.length > 5 ? textStoryElements[3].id : null;
};

const getElements = (element, story, card, elementIndex, cardIndex) => {
  const primaryEmbed = getPrimaryEmbed(story);
  const primaryEmbedId = primaryEmbed?.id ? primaryEmbed.id : null;
  if (
    element.id === primaryEmbedId &&
    (story["story-template"] == "embed" ||
      story["story-template"] == "video-playlist" ||
      story["story-template"] == "podcast")
  ) {
    return null;
  }
  const elementType = element.type;
  const [toggleSharing, setToggleSharing] = useState(false);
  const sharingHandler = () => {
    setToggleSharing(!toggleSharing);
  };

  if (element.metadata?.["promotional-message"] === true) {
    return null;
  }

  if (element.type === "text" && element?.subtype === null && cardIndex === 0) {
    return (
      <div id="text-element-with-ad">
        <StoryElement element={element} key={element.id} story={story} />
      </div>
    );
  }

  switch (element.subtype) {
    case "attachment": {
      return <Attachment element={element} />;
    }
    case "references": {
      const referenceObj = get(element, ["story-elements"], []);
      return referenceObj.map((element, index) => <ReferenceElement element={element} key={index} />);
    }
    case "image-gallery": {
      if (element.metadata.type === "gallery") {
        return <WithLazy margin="50px">{() => <ImageGallery element={element} story={story} />}</WithLazy>;
      }

      if (element.metadata.type === "slideshow") {
        return <WithLazy margin="50px">{() => <Slideshow story={story} element={element} />}</WithLazy>;
      }
      break;
    }
    case "blockquote": {
      return (
        <div styleName="blockquote-wrapper">
          <BlockQuoteIcon width="40" height="40px" />
          <StoryElement element={element} key={element.id} story={story} />
        </div>
      );
    }
    case "also-read": {
      return <AlsoRead element={element} story={story} />;
    }
    case "quote": {
      return (
        <div styleName="quote-contents" className="exclusive-contents">
          <QuoteIcon />
          <StoryElement element={element} key={element.id} story={story} />
        </div>
      );
    }
    case "q-and-a": {
      return <QandA element={element} story={story} subtype={element.subtype} />;
    }
    case "question": {
      return <QandA element={element} story={story} subtype={element.subtype} />;
    }
    case "answer": {
      return <QandA element={element} story={story} subtype={element.subtype} />;
    }
    case "table": {
      if (element.metadata["has-header"] == true) {
        const updateEle = { ...element };
        updateEle.metadata["has-header"] = false;
        return (
          <div className="has-head story-element story-element-data">
            <StoryElement element={updateEle} key={updateEle.id} story={story} />;
          </div>
        );
      } else {
        return <StoryElement element={element} key={element.id} story={story} />;
      }
    }
    default:
      if (elementType === "image") {
        if (
          story["story-template"] === "photo" ||
          story["story-template"] === "text-new" ||
          story["story-template"] === "sponsored"
        ) {
          return (
            <div styleName="share-wrapper">
              <StoryElement
                renderTemplates={{ image: ImagewithCaption }}
                element={element}
                key={element.id}
                story={story}
              />
            </div>
          );
        } else {
          return (
            <StoryElement
              renderTemplates={{ image: ImagewithCaptionWithoutShare }}
              element={element}
              key={element.id}
              story={story}
            />
          );
        }
      } else {
        return (
          <div styleName="share-wrapper">
            {story["story-template"] !== "podcast" || story["story-template"] !== "video-playlist" ? (
              <StoryElement element={element} key={element.id} story={story} loadIframeOnClick />
            ) : elementType !== "jsembed" ? (
              <StoryElement element={element} key={element.id} story={story} loadIframeOnClick />
            ) : element.subtype === "" || element.subtype === null ? (
              console.log("element.subtype ignored:>:>:>:>:>", elementType, element.subtype)
            ) : (
              <StoryElement element={element} key={element.id} story={story} loadIframeOnClick />
            )}
          </div>
        );
      }
  }
};

export const StoryCard = ({ story, card, cardIndex, index, isNewTextStory, showAlsoReadOnTop = true }) => {
  const elements = card["story-elements"];
  const wrappedAllElementCard = (elements, story, card, cardIndex) => {
    let allAlsoReads = [];
    let allWrappedElements = [];

    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];

      if (element.subtype === "also-read") {
        allAlsoReads.push(element);
      } else {
        if (allAlsoReads.length > 1) {
          allWrappedElements.push(
            <div styleName="also-read-main-wrapper">
              {allAlsoReads.map((element, elementIndex) => (
                <AlsoRead story={story} element={element} isConsecutive={true} elementIndex={elementIndex} />
              ))}
            </div>
          );
        } else {
          allWrappedElements.push(
            ...allAlsoReads.map((element, elementIndex) => (
              <AlsoRead story={story} element={element} isConsecutive={false} elementIndex={elementIndex} />
            ))
          );
        }

        allAlsoReads = [];
        allWrappedElements.push(getElements(element, story, card, i, cardIndex));
      }
    }
    if (allAlsoReads.length > 1) {
      allWrappedElements.push(
        <div styleName="also-read-main-wrapper">
          {allAlsoReads.map((element, elementIndex) => (
            <AlsoRead story={story} element={element} isConsecutive={true} elementIndex={elementIndex} />
          ))}
        </div>
      );
    } else {
      allWrappedElements.push(
        ...allAlsoReads.map((element, elementIndex) => (
          <AlsoRead story={story} element={element} isConsecutive={false} elementIndex={elementIndex} />
        ))
      );
    }
    return allWrappedElements;
  };
  return (
    <div
      styleName={`story-card ${isNewTextStory ? "card-border" : ""}`}
      key={card.id}
      id={card.id}
      className="story-card"
    >
      {wrappedAllElementCard(elements, story, card, cardIndex).map((element, elementIndex) => {
        const elementType = element?.props?.children?.props?.element?.type;
        return (
          <React.Fragment key={elementIndex}>
            <React.Fragment>{element}</React.Fragment>
            {fourthTextStoryElementID(story) === element?.id &&
            (story["story-template"] === "text" || story["story-template"] === "syndicated") ? (
              <SectionStories story={story} />
            ) : null}
            {cardIndex === 0 && elementIndex === 0 && elementType !== "text" ? (
              <>
                <div styleName="ad-wrapper" key={index}>
                  <AdContainer
                    AdClassName="standard-336x280"
                    id="div-gpt-ad-1680156704803-0"
                    desktop="DH_Desktop_AT_Mid"
                    mobile="DH_MWeb_AT_Mid"
                  />
                </div>
              </>
            ) : null}
          </React.Fragment>
        );
      })}
    </div>
  );
};

const getUpdatedCards = (cards) => {
  const updatedCards = [];
  let alsoReadElements = [];

  for (let card = 0; card < cards.length; card++) {
    const firstCard = cards[card];
    const secondCard = cards[card + 1];
    const firstCardLastElement = firstCard["story-elements"][firstCard["story-elements"].length - 1];
    const lastCard = cards[cards.length - 1];

    if (firstCardLastElement?.subtype === "also-read" && secondCard) {
      for (let element = 0; element < secondCard["story-elements"].length; element++) {
        if (secondCard["story-elements"][element]?.subtype === "also-read") {
          alsoReadElements.push(secondCard["story-elements"][element]);
        } else {
          break;
        }
      }
      firstCard["story-elements"] = [...firstCard["story-elements"], ...alsoReadElements];
      updatedCards.push(firstCard);
      const updatedsecondCardElements = secondCard["story-elements"].filter(
        (element) => !alsoReadElements.includes(element)
      );
      secondCard["story-elements"] = updatedsecondCardElements;
      if (secondCard.id === lastCard.id) {
        updatedCards.push(secondCard);
      }
    } else {
      if (!updatedCards.includes(firstCard)) {
        updatedCards.push(firstCard);
      }
    }
    alsoReadElements = [];
  }

  return updatedCards;
};

const StoryElements = ({
  story,
  index,
  cards,
  isPodcast = false,
  isFactCheck,
  isMovieReview,
  isGadgetReview,
  isBookReview,
  isSponsoredStory,
  isEmbed,
  isNewTextStory
}) => {
  const template = story["story-template"] ? story["story-template"] : "text";
  const [isMobile, setMobile] = useState(false);
  const [renderTaboolaAd, setRenderTaboolaAd] = useState(false);

  useEffect(() => {
    const getScroll = () => {
      if (typeof window !== "undefined") {
        if (window.scrollY > 500) setRenderTaboolaAd(true);
      }
    };
    window.addEventListener("scroll", throttle(getScroll, 500));
    return () => window.removeEventListener("scroll", getScroll);
  }, []);

  useEffect(() => {
    if (window && window.innerWidth < 767) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  }, []);

  useEffect(() => storyPageBodyAd(story), []);
  const updateCards = getUpdatedCards(cards);

  const isExclusiveStory = story["story-template"] === "dh-exclusive";
  return (
    <div styleName="wrapper">
      {isMovieReview && <MovieReviewView story={story} />}
      {isGadgetReview && <GadgetReviewView story={story} />}
      {isBookReview && <BookReviewView story={story} />}
      <div id={`story-content-${story.id}`} className="story-cards taboola-read-more-container">
        {updateCards.map((card, cardIndex) => (
          <StoryCard
            card={card}
            story={story}
            key={card.id}
            cardIndex={cardIndex}
            index={index}
            isNewTextStory={isNewTextStory}
          />
        ))}

        {fourthTextStoryElementID(story) === null &&
        (story["story-template"] === "text" || story["story-template"] === "syndicated") ? (
          <SectionStories story={story} />
        ) : null}
        {isFactCheck && <FactCheckView story={story} />}
        {isSponsoredStory && <SponsoredTag />}
        <div styleName="ad-wrapper" className="hide-desktop">
          <AdContainer AdClassName="standard-336x280" id="div-gpt-ad-1680157888251-0" mobile="DH_MWeb_AT_Bottom" />
        </div>
        {!isExclusiveStory && <PublishedAt story={story} />}
        <Tags story={story} />
        <PromotionalMessage story={story} />
        <SubscribeCard story={story} />
        {isMobile ? (
          <div className="side-story-section hide-desktop">
            <MobileBottomWidgets index={index} story={story} />
          </div>
        ) : null}
        <div styleName="temp-ad">
          <AdContainer
            AdClassName="standard-336x280"
            id={`div-gpt-ad-1680156704803-0`}
            desktop="DH_Desktop_AT_Mid"
            className="hide-mobile"
          />
          <AdContainer
            AdClassName="standard-336x280"
            id={`div-gpt-ad-1680157855094-0`}
            mobile="DH_MWeb_AT_Mid"
            className="hide-desktop"
          />
        </div>
      </div>
      {/* {renderTaboolaAd ? ( */}
      <TaboolaAd
        container={`'taboola-below-article-${story.id}`}
        placement={`Below ${template === "video" ? "Video" : template === "photo" ? "Photo" : "Article"} Thumbnails`}
        mode="thumbnails-b"
      />
      {/* ) : null} */}
    </div>
  );
};

StoryElements.defaultProps = {
  isPodcast: false,
  isFactCheck: false,
  isMovieReview: false,
  isGadgetReview: false,
  isSponsoredStory: false,
  isEmbed: false
};

export default StoryElements;
